import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmptyState } from "core/components/empty-state";
import { strings } from "localization";

export const ComingSoon = () => {
  return (
    <EmptyState
      title={strings.comingSoon.title}
      text1={strings.comingSoon.contactsText}
      showButton={false}
      mainIcon={<FontAwesomeIcon icon={["fad", "address-book"]} size="10x" />}
    />
  );
};
